import { CustomColumn } from '../../types/customColumn';
import { DocumentTemplateSummary } from '../../types/documentTemplate/ElectronicDocumentTemplateTypes';

export const documentTemplateColumns: CustomColumn<DocumentTemplateSummary>[] =
  [
    {
      Header: 'Documento',
      accessor: 'documentTypeName', // Asumimos que en el summary ya viene el nombre del tipo de documento
      customCell: ({ row }) => (
        <span className="text-gray-700 dark:text-gray-300 text-sm">
          {row.original.documentTypeName}
        </span>
      ),
    },
    {
      Header: 'Versión',
      accessor: 'version',
      customCell: ({ row }) => (
        <span className="text-sm">{row.original.version}</span>
      ),
    },
    {
      Header: 'Descripción',
      accessor: 'description',
      customCell: ({ row }) => (
        <span className="text-gray-700 dark:text-gray-300 text-sm">
          {row.original.description}
        </span>
      ),
    },

    {
      Header: 'Estado',
      accessor: 'active',
      customCell: ({ row }) => {
        const status = row.original.active ? 'Activo' : 'Inactivo';
        const badgeClass = row.original.active
          ? 'bg-[#3CA745] text-white'
          : 'bg-[#DC3545] text-white';

        return (
          <span
            className={`inline-flex rounded-full px-3 py-1 text-sm font-medium ${badgeClass}`}
          >
            {status}
          </span>
        );
      },
    },
  ];
